var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _rect2, _rect3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 93,
    viewBox: "0 0 96 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0H87.7308L96 7.84783V58H52V0Z",
    fill: "#F1F5FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32.6667H81.6667V29H78V32.6667ZM78.9167 29.9167H80.75V31.75H78.9167V29.9167Z",
    fill: "#BFD4F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 37.2497H81.6667V33.583H78V37.2497ZM78.9167 34.4997H80.75V36.333H78.9167V34.4997Z",
    fill: "#BFD4F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5834 29V32.6667H86.25V29H82.5834ZM85.3334 31.75H83.5V29.9167H85.3334V31.75Z",
    fill: "#BFD4F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.25 36.333H85.3334V37.2497H86.25V36.333Z",
    fill: "#BFD4F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 33.583H82.5834V34.4997H83.5V33.583Z",
    fill: "#BFD4F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4167 34.5H83.5V35.4167H84.4167V34.5Z",
    fill: "#BFD4F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 35.417H82.5834V36.3337H83.5V35.417Z",
    fill: "#BFD4F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4167 36.333H83.5V37.2497H84.4167V36.333Z",
    fill: "#BFD4F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3333 35.417H84.4166V36.3337H85.3333V35.417Z",
    fill: "#BFD4F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3333 33.583H84.4166V34.4997H85.3333V33.583Z",
    fill: "#BFD4F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.25 34.5H85.3334V35.4167H86.25V34.5Z",
    fill: "#BFD4F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9999 7.85577L87.7307 7.85577L87.7307 0L95.9999 7.85577Z",
    fill: "#BFD4F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 13,
    width: 24,
    height: 2,
    fill: "#BFD4F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 18,
    width: 24,
    height: 2,
    fill: "#BFD4F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 23,
    width: 24,
    height: 2,
    fill: "#BFD4F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.898 30.8047L41.5059 30.6465L45.2621 42.5373L44.5221 42.4885L44.5642 42.6152L53.5707 42.35L54.4653 34.7601L43.898 30.8047Z",
    fill: "#3E4448"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2621 42.5376L36.4042 14.49C36.204 13.855 35.6736 13.3165 35.2205 13.2863C35.0928 13.2782 34.9886 13.3142 34.9043 13.3793L2.94128 31.7145L3.4799 33.9242L3.52205 34.0952L11.8131 58.6793L13.1644 60.9461L44.6099 42.7551L44.522 42.49L45.2621 42.5388V42.5376Z",
    fill: "#455E77"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1841 14.019C35.9289 13.6085 35.5542 13.3084 35.2193 13.2863C35.0917 13.2782 34.9875 13.3142 34.9032 13.3793L2.94128 31.7145L3.22581 32.8822C3.45648 32.7728 3.68129 32.6577 3.8979 32.5344L36.1841 14.019Z",
    fill: "#5C6366"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12273 31.6918C2.66959 31.6615 2.46468 32.1523 2.66491 32.7873L11.5227 60.8349L13.1643 60.9431L4.3065 32.8967C4.10628 32.2616 3.57586 31.7232 3.12273 31.6929V31.6918Z",
    fill: "#3E4448"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5012 41.8814L30.75 8L3.74573 23.4857L14.169 55.0701L15.2732 56.9217L40.9684 42.0582L40.8958 41.8418L41.5012 41.8814Z",
    fill: "#F1F2F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.728 57.9839L36.9768 24.1025L9.97253 39.5883L20.397 71.1727L21.5012 73.0242L47.1952 58.1607L47.1238 57.9444L47.728 57.9839Z",
    fill: "#D1D3D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.728 56.5913L36.9768 22.71L9.97253 38.1957L20.397 69.7801L21.5012 71.6316L47.1952 56.7669L47.1238 56.5506L47.728 56.5913Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4809 57.522C15.3996 56.388 1 54.8633 1 54.8633V77.4691H1.00234C1.01522 78.8391 1.93203 80.208 3.75511 81.2536L21.4941 91.4266C23.4168 92.5292 25.9634 93.049 28.4809 92.9979L29.8215 79.7033L28.4809 57.522Z",
    fill: "#D1D3D4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1565 58.2451C50.8941 59.2418 40.2179 58.5393 28.4808 57.5217V92.9964C30.7758 92.9499 33.0461 92.43 34.7978 91.4251L74.9196 68.4169C76.8059 67.3353 77.7169 65.9083 77.6654 64.4894H77.6701V42.0859L49.1565 58.2439V58.2451Z",
    fill: "#BCBEC0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1 58.5675H1.00234C1.01522 59.9387 1.93203 61.3065 3.75511 62.352L21.4941 72.525C23.4168 73.6276 25.9634 74.1475 28.4809 74.0963L29.8215 70.1001L28.4809 57.5231C15.3996 56.388 1 54.8633 1 54.8633V58.5664V58.5675Z",
    fill: "#626A88"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4808 57.5217V74.0948C30.7758 74.0483 33.0461 73.5284 34.7978 72.5236L74.9196 49.5142C76.8059 48.4326 77.7169 47.0056 77.6654 45.5867H77.6701V42.0859L49.1565 58.2439C50.8941 59.2406 40.2179 58.5382 28.4808 57.5205V57.5217Z",
    fill: "#455E77"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1565 38.4502L44.7176 35.9043L12.7593 54.2313C12.7124 54.2581 12.6609 54.2813 12.6129 54.3069L17.0588 56.8563C20.7319 58.9637 26.6894 58.9637 30.3625 56.8563L49.1565 46.0785C52.8296 43.9722 52.8296 40.5564 49.1565 38.449V38.4502Z",
    fill: "#333A3D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9185 38.4098L57.1794 28.2368C53.5052 26.1294 47.5488 26.1294 43.8757 28.2368L41.2248 29.7569L41.8267 31.6631L49.1553 35.8663C52.8296 37.9725 52.8296 41.3895 49.1553 43.4958L30.3613 54.2735C26.6882 56.3798 20.7319 56.3798 17.0576 54.2735L7.7654 48.9445L3.75392 51.245C0.0808232 53.3513 0.0796525 56.7671 3.75392 58.8745L21.4929 69.0475C25.1672 71.1538 31.1236 71.1538 34.7966 69.0475L74.9185 46.0393C78.5916 43.9331 78.5916 40.5172 74.9185 38.4098Z",
    fill: "#6D78A7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.1
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6817 50.0767L30.3625 54.274C26.6894 56.3803 20.733 56.3803 17.0588 54.274L9.58496 49.9883L24.1919 70.1238C27.6706 71.0484 31.9291 70.6949 34.7978 69.0492L46.5536 62.3071L37.6817 50.0767Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4717 27.9287C44.2691 28.0264 44.0677 28.1276 43.8769 28.2369L41.226 29.757L41.8278 31.6632L49.1564 35.8664C52.8307 37.9726 52.8307 41.3896 49.1564 43.4959L45.6812 45.4881L54.5531 57.7185L62.6943 53.049L44.4717 27.9287Z",
    fill: "white"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73.768L82.2296 73.3842C81.7717 72.7736 81.1149 72.199 80.2449 71.7001L70.9527 66.3711L54.9044 75.5741V91.6833C57.2766 91.6681 59.6407 91.1436 61.4509 90.1062L80.2449 79.3284C82.0211 78.3096 82.9297 76.9861 82.9883 75.6509L83 73.7668V73.768Z",
    fill: "#455E77"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9055 75.5742L40.9742 83.5631C40.0141 83.3502 38.8561 83.0827 38.8561 83.0827V84.7784L48.1483 90.1074C50.0124 91.1763 52.463 91.7008 54.9055 91.6845V75.5754V75.5742Z",
    fill: "#626A88"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2448 70.0042L62.7165 59.9521L45.5079 69.8205C41.8489 71.9186 38.8561 77.0685 38.8561 81.2647V83.0825L48.1471 88.4115C51.8214 90.5189 57.7777 90.5189 61.4508 88.4115L80.2448 77.6337C83.9179 75.5274 83.9179 72.1116 80.2448 70.0042Z",
    fill: "#6D78A7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3333 58.3126C67.2116 57.9683 65.8159 58.1742 64.3019 59.043L62.7166 59.9524L69.9855 64.1196V63.0031L69.2536 59.3093L68.3333 58.3126Z",
    fill: "#2A3033"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0897 58.2334C68.8356 59.0382 69.2759 60.2815 69.2759 61.8958V63.7136L70.9526 64.6766V62.8588C70.9526 60.2606 69.818 58.6195 68.0874 58.2334H68.0897Z",
    fill: "#D1D3D4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1388 87.3201L77.944 71.375L60.2718 61.3555L45.5091 69.8212C41.9461 71.8646 39.0236 76.7993 38.8713 80.9316L50.1388 87.3201Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9444 86.8584L77.9429 71.375L60.2706 61.3555L45.5079 69.8212C42.1955 71.7215 39.4357 76.1225 38.9427 80.0523L50.9444 86.8572V86.8584Z",
    fill: "#D1D3D4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7792 87.3197L80.5832 71.3745L61.5832 60.6025L45.5068 69.8219C42.343 71.6362 39.6816 75.7312 39.0177 79.5192L52.7769 87.3208L52.7792 87.3197Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0066 65.8068V66.0383H26.8779V65.8941H26.0407V65.8394H25.7398V65.8068H25.344V66.4686C25.3534 66.6838 25.5009 66.8977 25.7866 67.0617C26.0828 67.2315 26.4704 67.3153 26.858 67.3153C26.858 67.3153 26.8697 67.3153 26.8755 67.3153C27.2572 67.313 27.6389 67.2281 27.9305 67.0606C28.2267 66.8908 28.3743 66.6686 28.3743 66.4453V65.8057H28.0043L28.0066 65.8068Z",
    fill: "#57AA00"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9329 66.4215C27.3404 66.7611 26.3814 66.7611 25.789 66.4215C25.1965 66.0819 25.1965 65.5318 25.789 65.1922C26.3814 64.8526 27.3404 64.8526 27.9329 65.1922C28.5253 65.5318 28.5253 66.0819 27.9329 66.4215Z",
    fill: "#6FCE1B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1633 67.6172V67.8486H30.0346V67.7044H29.1974V67.6498H28.8965V67.6172H28.5007V68.279C28.5101 68.4941 28.6576 68.7081 28.9433 68.8721C29.2396 69.0419 29.6271 69.1256 30.0147 69.1256C30.0147 69.1256 30.0264 69.1256 30.0323 69.1256C30.414 69.1233 30.7957 69.0384 31.0872 68.8721C31.3835 68.7023 31.531 68.4802 31.531 68.2569V67.6172H31.161H31.1633Z",
    fill: "#FFA300"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0896 68.2321C30.4971 68.5717 29.5382 68.5717 28.9457 68.2321C28.3532 67.8925 28.3532 67.3424 28.9457 67.0028C29.5382 66.6631 30.4971 66.6631 31.0896 67.0028C31.6821 67.3424 31.6821 67.8925 31.0896 68.2321Z",
    fill: "#FFCA00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4506 63.3234V63.6607H22.809V63.4502H21.5912V63.3711H21.1545V63.3234H20.5796V64.2853H20.5808C20.5948 64.5993 20.8091 64.9098 21.2248 65.1482C21.6556 65.3948 22.22 65.5169 22.7832 65.5169C22.7914 65.5181 22.7996 65.5169 22.8078 65.5169C23.364 65.5134 23.9178 65.3901 24.3417 65.1471C24.7726 64.9005 24.9868 64.576 24.9868 64.2527V63.3223H24.4482L24.4506 63.3234Z",
    fill: "#BCBEC0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3429 64.2169C23.4823 64.7112 22.0854 64.7112 21.2248 64.2169C20.3642 63.7226 20.3642 62.9224 21.2248 62.4293C22.0854 61.935 23.4823 61.935 24.3429 62.4293C25.2035 62.9236 25.2035 63.7238 24.3429 64.2169Z",
    fill: "#DDDDDD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.0f7c4cf859a49a8e7079080524912dc4.svg";
export { ForwardRef as ReactComponent };